"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var DomainListCtl = /** @class */ (function (_super) {
    __extends(DomainListCtl, _super);
    function DomainListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_domain_name = UIUtils_1.UIUtils.IProp2Str(function (o) { o.domain_template; });
        _this.dk_description = UIUtils_1.UIUtils.IProp2Str(function (o) { o.description; });
        _this.dk_is_locked = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_locked; });
        _this.dk_date_added2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added2; });
        _this.dk_date_changed2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed2; });
        _this.dk_brand_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_id; });
        _this.dk_brand_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_title; });
        _this.dk_order_number = UIUtils_1.UIUtils.IProp2Str(function (o) { o.order_number; });
        _this.dk_app_country_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_country_id; });
        _this.dk_app_country_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_country_title; });
        _this.dk_domain_type_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.domain_type_code; });
        _this.dk_domain_type_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.domain_type_title; });
        _this._errDialog = errDialog;
        return _this;
    }
    DomainListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total: 0
        };
    };
    DomainListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "domain with id [" + id + "] not found !";
    };
    DomainListCtl.prototype.LoadData = function (AllBrands, BrandIdList, onDone) {
        var _this = this;
        webAApi_1.ListBrandDomainsByBrandIdGet.exec({ all_brands: AllBrands, brand_id_list: BrandIdList }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    brand_id: resp.list[i].brand_id,
                    brand_title: resp.list[i].brand_title,
                    domain_template: resp.list[i].domain_template,
                    description: resp.list[i].description,
                    is_locked: resp.list[i].is_locked,
                    date_added2: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed2: moment(resp.list[i].date_changed_uts_ms).utc(false),
                    order_number: resp.list[i].order_number,
                    app_country_id: resp.list[i].app_country_id,
                    app_country_title: resp.list[i].app_country_title,
                    domain_type_code: resp.list[i].domain_type_code,
                    domain_type_title: resp.list[i].domain_type_title
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    DomainListCtl.prototype.LoadDataEx = function (AllBrands, BrandIdList, allCountries, CountryList, onDone) {
        var _this = this;
        webAApi_1.ListBrandDomainsByBrandAndCountryGet.exec({
            all_brands: AllBrands,
            brand_id_list: BrandIdList,
            all_country: allCountries,
            country_id_list: CountryList
        }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    brand_id: resp.list[i].brand_id,
                    brand_title: resp.list[i].brand_title,
                    domain_template: resp.list[i].domain_template,
                    description: resp.list[i].description,
                    is_locked: resp.list[i].is_locked,
                    date_added2: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed2: moment(resp.list[i].date_changed_uts_ms).utc(false),
                    order_number: resp.list[i].order_number,
                    app_country_id: resp.list[i].app_country_id,
                    app_country_title: resp.list[i].app_country_title,
                    domain_type_code: resp.list[i].domain_type_code,
                    domain_type_title: resp.list[i].domain_type_title
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    DomainListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddBrandDomain.exec({
            data: {
                brand_id: data.brand_id,
                description: data.description,
                domain_template: data.domain_template,
                is_locked: data.is_locked,
                order_number: data.order_number,
                app_country_id: data.app_country_id,
                domain_type_code: data.domain_type_code
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                date_changed2: moment(resp.date_changed_uts_ms).utc(false),
                date_added2: moment(resp.date_added_uts_ms).utc(false),
                domain_template: data.domain_template,
                description: data.description,
                brand_title: resp.brand_title,
                brand_id: data.brand_id,
                is_locked: data.is_locked,
                order_number: data.order_number,
                app_country_id: data.app_country_id,
                app_country_title: resp.app_country_title,
                domain_type_code: data.domain_type_code,
                domain_type_title: resp.domain_type_title
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    DomainListCtl.prototype.EditData = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoEditBrandDomain.exec({
                data: {
                    domain_id: data.key,
                    domain_template: data.domain_template,
                    order_number: data.order_number,
                    description: data.description,
                    is_locked: data.is_locked,
                    app_country_id: data.app_country_id,
                    domain_type_code: data.domain_type_code
                }
            }, function (resp) {
                _tmp.description = data.description;
                _tmp.domain_template = data.domain_template;
                _tmp.is_locked = data.is_locked;
                _tmp.order_number = data.order_number;
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _tmp.app_country_id = data.app_country_id;
                _tmp.app_country_title = resp.app_country_title;
                _tmp.domain_type_code = data.domain_type_code,
                    _tmp.domain_type_title = resp.domain_type_title;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    DomainListCtl.prototype.RemoveItem = function (key) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === key) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    DomainListCtl.prototype.DeleteDomain = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeleteBrandDomain.exec({ data: { domain_id: key } }, function (resp) {
                _this.RemoveItem(_tmp.key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    DomainListCtl.prototype.doSetIsLocked = function (key, isLocked, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetBrandDomainIsLocked.exec({ data: { domain_id: key, is_locked: isLocked } }, function (resp) {
                _tmp.is_locked = isLocked;
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    DomainListCtl.prototype.doSetDomainOrderNumber = function (key, OrderNumber, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetBrandDomainPriority.exec({ data: { domain_id: key, order_number: OrderNumber } }, function (resp) {
                _tmp.order_number = OrderNumber;
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return DomainListCtl;
}(BaseController_1.BaseController));
exports.DomainListCtl = DomainListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_domains_list/ctl/DomainListCtl.ts
// module id = 935
// module chunks = 0